module.exports = __webpack_public_path__ + "log green-70347f29d9e596ead4dd.svg";